import { useFormatter } from "next-intl";

import intlUtils from "~/utils/intl-utils";

import styles from "./product-stacked-price.module.scss";

type Props = {
  product: EVA.Core.GetProductDetailResponse["Result"];
};

export default function ProductStackedPrice(props: Props) {
  const { display_price, original_price, currency_id: currency } = props.product;

  const formatter = useFormatter();
  const priceFormatter = intlUtils.usePriceFormatter();

  return (
    <div className={styles.priceInfo}>
      <span className={styles.displayPrice}>{priceFormatter.currency(display_price, { currency })}</span>
      {original_price && (
        <>
          <span className={styles.discountAmount}>
            {formatter.number(display_price / original_price - 1, { style: "percent", maximumFractionDigits: 0 })}
          </span>
          <span className={styles.cutPrice}>{priceFormatter.currency(original_price, { currency })}</span>
        </>
      )}
    </div>
  );
}
